import { TreeNode } from 'primeng/api';

export class p2p_result_node {
    normMedDescription!: string;
    p2pMedId!: string;
    locationGrouping!: string;
    locationGroupingValue!: number;
    medGroupName!: string;
    adminId!: string;
    adminName!: string;
    transactionType!: string;
    children!: any[];
    adminGroupingValue!: string;
    normAdminType!: string;
    shiftworked!: string;
    numberOfStandardDeviationsMean!: number;
    totalCountofPtscaredforbyAdmin!: number;
    adminFlagCount!: number;
    shiftDate!: string;
    shiftIndex!: string;
    PatientPerShiftStandardDevsFromMean!: number;
    correctionFactor!: number;
    PatientNumStandardDevsFromMean!: number;
    groupFlagTotal!: number;
    groupTotalPatients!: number;
    averageAdminPatientCount!: number;
    groupTotalPerPatient_Avg!: number;
    adminMedBYAdminPts!: number;
    patientPerShift_Mean!: number;
    patientsPerShift!: number;
    flagCountAvg!: number;
    uom!: string;
    groupSize!: number;
    fullGroup_patientPerShift_Mean!: number;
    fullGroup_groupTotalPerPatient_Avg!: number;
    fullGroup_averageAdminPatientCount!: number;
    fullGroup_groupTotalPatients!: number;
    fullGroup_groupSize!: number;
    fullGroup_flagCountAvg!: number;
    fullGroup_groupPatientCount!: number;
    flagsPerPatientScore!: number;
    adjustmentFactor!: number;
    patientsPerShiftScore!: number;
    patientsPerShiftStd!:number;
    correctedFlagsPerPatientStd!:number;




    static fromJSON(object: any) {
        const resultNode = new p2p_result_node();
        resultNode.children = object['children'];
        resultNode.medGroupName = object.medGroupName;
        resultNode.p2pMedId = object.p2pMedId
        resultNode.adminId = object.adminId;
        resultNode.PatientPerShiftStandardDevsFromMean = object.PatientPerShiftStandardDevsFromMean
        resultNode.patientsPerShift = object.patientsPerShift
        resultNode.flagCountAvg = object.flagCountAvg
        resultNode.uom = object.uom
        resultNode.groupSize = object.groupSize
        resultNode.fullGroup_patientPerShift_Mean = object.fullGroup_patientPerShift_Mean
        resultNode.fullGroup_groupTotalPerPatient_Avg = object.fullGroup_groupTotalPerPatient_Avg
        resultNode.fullGroup_averageAdminPatientCount = object.fullGroup_averageAdminPatientCount
        resultNode.fullGroup_groupTotalPatients = object.fullGroup_groupTotalPatients
        resultNode.fullGroup_groupSize = object.fullGroup_groupSize
        resultNode.fullGroup_flagCountAvg = object.fullGroup_flagCountAvg
        resultNode.fullGroup_groupPatientCount = object.fullGroup_groupPatientCount
        resultNode.patientPerShift_Mean = object.patientPerShift_Mean
        resultNode.groupTotalPerPatient_Avg = object.groupTotalPerPatient_Avg
        resultNode.averageAdminPatientCount = object.averageAdminPatientCount
        resultNode.adminMedBYAdminPts = object.adminMedBYAdminPts
        resultNode.correctionFactor = object.correctionFactor
        resultNode.PatientNumStandardDevsFromMean = object.PatientNumStandardDevsFromMean
        resultNode.groupTotalPatients = object.groupTotalPatients
        resultNode.groupFlagTotal = object.groupFlagTotal
        resultNode.adminName = object.adminName;
        resultNode.adjustmentFactor = object.adjustmentFactor;
        resultNode.locationGrouping = object.locationGrouping;
        resultNode.locationGroupingValue = object.locationGroupingValue;
        resultNode.transactionType = object.transactionType;
        resultNode.adminGroupingValue = object.adminGroupingValue;
        resultNode.normAdminType = object.normAdminType;
        resultNode.shiftworked = object.shiftworked;
        resultNode.numberOfStandardDeviationsMean = object.numberOfStandardDeviationsMean;
        resultNode.totalCountofPtscaredforbyAdmin = object.totalCountofPtscaredforbyAdmin;
        resultNode.adminFlagCount = object.adminFlagCount;
        resultNode.flagsPerPatientScore = object.flagsPerPatientScore
        resultNode.patientsPerShiftScore = object.patientsPerShiftScore
        resultNode.patientsPerShiftStd = object.PatientPerShiftStandardDevsFromMean
        resultNode.correctedFlagsPerPatientStd = object.correctedFlagsPerPatientStd
        return resultNode;
      }

      static toTreeNode(resultNode: p2p_result_node): TreeNode {
        const node = ({ data: Object.assign({}, resultNode), children: [{ data: { label: "Shift Summaries" }, children: [{}] }], leaf: true, expanded: false, parent: null } as unknown) as TreeNode
        return node
      }
}